import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";
import buildFilters from "../../utils/filterLogic";
import { listPath } from "../../utils/constants/insightsPath";

export const exportDataApi = async (verb,source,filters,fileType,authHeaders,companyId) => {

    const filterWithCompanyId = {
        ...filters,
        companyId: companyId
    };
    const inputData = {
        channel: "CRM",
        verb: verb,
        source: source,
        exportsCriteria:JSON.stringify(buildFilters(
            source === "COMPLAINTS" ? listPath.COMPLAINTS : 
            source === "QRCODE" ? listPath.QRCODE : 
            listPath.PRODUCT, 
            filterWithCompanyId
        )),
        fileType: fileType
    };
    try {
        const res = await apiCallPost(apiPaths.exportData, inputData, authHeaders);
        if(res && res.exportId) {
            sessionStorage.setItem('exportRequestedTimestamp', res.requestedTimestamp);
            return {data: res, status: true}
        }
        return {data: [], status: false, errMsg: 'Some Error Occured'};
    }catch(err) {
        return {status: false, errMsg: err.message}
    }
};